import uuid from 'uuid-random';
import { addPopupAction, LAYER } from 'js/components/common/PopupManager';
import { getFidoAuthenticators } from './server';

const popupId = uuid();

export const showNevisPopupAction = (data = {}, component: any) =>
    addPopupAction({
        id: popupId,
        layer: LAYER.COMMON,
        component,
        ...data
    });

export const fetchNevisPasskeys = async () => {
    try {
        return await getFidoAuthenticators();
    } catch (error) {
        return false;
    }
};
